<button (click)="togglePassword()"
    class="button button--icon button--icon-transparent sign-in-screen__toggle-password" id="toggle-password"
    type="button">
    <svg-icon class="flex" *ngIf="hidePassword === 'password'" name="ico-preview-16" [svgStyle]="{ 'width.px':16, 'height.px': 16,'fill': 'currentColor' }">
    </svg-icon>
    <svg-icon class="flex" *ngIf="hidePassword === 'text'" name="ico-preview-hide-16" [svgStyle]="{ 'width.px':16, 'height.px': 16,'fill': 'currentColor' }">
    </svg-icon>
</button>
